module.exports = __webpack_public_path__ + "static/img/culture_02.b9843ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/culture_02.png
// module id = FM6S
// module chunks = 0